import { FC, ReactNode } from 'react';
import { Circle, Heading, Text, VStack } from '@chakra-ui/react';

export type NewAccountHeaderProps = {
  icon: ReactNode;
  title: string;
  description: string;
};

export const NewAccountHeader: FC<NewAccountHeaderProps> = ({ icon, title, description }) => (
  <VStack spacing={3} textAlign="center">
    <Circle size={12} bg="primary.100" color="primary.500">
      {icon}
    </Circle>
    <Heading size="lg">{title}</Heading>
    <Text color="neutral.500">{description}</Text>
  </VStack>
);
